const webinarOnDemandPost = (WpTag = '') => `
  databaseId
  date
  dateGmt
  id
  language {
    code
    locale
    name
    slug
  }
  link
  slug
  title
  uri
  seo {
    canonical
    cornerstone
    focuskw
    metaDesc
    metaKeywords
    metaRobotsNofollow
    metaRobotsNoindex
    opengraphAuthor
    opengraphDescription
    opengraphModifiedTime
    opengraphPublishedTime
    opengraphPublisher
    opengraphSiteName
    opengraphTitle
    opengraphType
    opengraphUrl
    readingTime
    title
    twitterDescription
    twitterTitle
    opengraphImage {
      sourceUrl
    }
    twitterImage {
      sourceUrl
    }
    breadcrumbs {
      text
      url
    }
    schema {
      articleType
      pageType
    }
  }
  webinarOnDemand {
    webinarOnDemandContent {
      webinarOnDemandContentBody
      webinarOnDemandContentSpeakersList {
        webinarOnDemandSpeakerAvatar {
          altText
          sourceUrl
        }
        webinarOnDemandSpeakerName
        webinarOnDemandSpeakerPosition
      }
      webinarOnDemandContentSpeakersTitle
    }
    webinarOnDemandCtaBlock {
      webinarOnDemandCtaBlockTitle
      webinarOnDemandCtaButtonTitle
      webinarOnDemandCtaSlidesFile {
        mediaItemUrl
      }
    }
    webinarOnDemandFormData {
      webinarOnDemandFormTitle
      webinarOnDemandFormSubmitButton
      webinarOnDemandFormLastNameLabel
      webinarOnDemandFormFirstNameLabel
      webinarOnDemandFormEmailLabel
    }
    webinarOnDemandHero {
      webinarOnDemandHeroBackgroundColor
      webinarOnDemandHeroBanner {
        altText
        sourceUrl
      }
      webinarOnDemandHeroDate
      webinarOnDemandHeroDescription
      webinarOnDemandHeroTags {
        webinarOnDemandHeroTagItem
      }
      webinarOnDemandHeroTitle
    }
    webinarOnDemandVideo {
      webinarOnDemandVideoButtonTitle
      webinarOnDemandVideoOriginal {
        mediaItemUrl
      }
      webinarOnDemandVideoPoster {
        altText
        sourceUrl
      }
      webinarOnDemandVideoProgressive {
        mediaItemUrl
      }
      webinarOnDemandVideoYoutube
      webinarOnDemandFreeVideoAccess
    }
  }
`;

module.exports.webinarOnDemandPost = webinarOnDemandPost;
